import SpanText, { SpanTextProps } from '@lyra/core/components/SpanText'
import formatPercentage from '@lyra/core/utils/formatPercentage'
import { YieldTokenId } from '@lyra/web/constants/yield'
import { YieldStackLayer } from '@lyra/web/constants/yieldCopy'
import useYieldStats from '@lyra/web/hooks/useYieldStats'
import { getYieldTokenConfig } from '@lyra/web/utils/yield'
import React from 'react'

type Props = {
  yieldId: YieldTokenId
  layer: YieldStackLayer
} & Omit<SpanTextProps, 'color'>

export default function YieldStackValueText({ yieldId, layer, ...textProps }: Props) {
  const { data, isLoading } = useYieldStats(getYieldTokenConfig(yieldId))

  const isDataApy = layer.isBase || layer.isOptions
  const yieldApy = layer.isBase ? data?.baseApy : layer.isOptions ? data?.optionsApy : undefined

  return (
    <SpanText
      color={layer.isActive ? (yieldApy ? 'green' : 'primary') : 'secondary'}
      {...textProps}
    >
      {isDataApy
        ? isLoading
          ? '...'
          : `${formatPercentage(yieldApy ?? 0, { showSign: !!yieldApy, dps: 2 })} APY`
        : layer.yieldValue
        ? layer.yieldValue
        : '-'}
    </SpanText>
  )
}
